import { consumer } from "./consumer";

const isUserLoggedIn = document
  .querySelector('meta[name="user-logged-in"]')
  ?.getAttribute("content");

if (isUserLoggedIn) {
  consumer.subscriptions.create("LogoutChannel", {
    received(data: { action?: string }) {
      if (data?.action === "logout") {
        window.location.assign("/logout");
      }
    }
  });
}
